import { Routes, Route, Link, HashRouter } from 'react-router-dom';
import './App.css';
import Recipe from './components/Recipe';
import React, { useEffect, useState } from 'react';
import { onSnapshot } from '@firebase/firestore';
import { recipesQuery } from './firebase';
import CreateRecipeForm from './components/CreateRecipeForm';
import { isAdmin } from './util';
import './i18n';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

const App = () => {
  const { t } = useTranslation();
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  const [recipes, setRecipes] = useState([]);

  useEffect(() => {
    onSnapshot(recipesQuery, querySnapshot => {
      setRecipes(
        querySnapshot.docs.map(doc => ({ id: doc.id, data: doc.data() }))
      );
    });
  }, []);

  return (
    <HashRouter>
      <button onClick={() => changeLanguage('en')} className="change-language">{t('en')}</button>
      <button onClick={() => changeLanguage('da')} className="change-language">{t('da')}</button>
      <h1>{t('recipes')}</h1>
      <div className="links">
        {recipes.map(recipe => (
          <Link key={recipe.data.path} to={recipe.data.path}>
            {recipe.data.title}
          </Link>
        ))}
        {isAdmin() && (
          <Link to="/create-recipe" className='create-recipe-link'>
            {t('createNewRecipe')}
          </Link>
        )}
      </div>
      <Routes>
        <Route path="/" element={<></>} />
        {isAdmin() && (
          <Route path="/create-recipe" element={<CreateRecipeForm />} />
        )}
        {recipes.map(recipe => (
          <Route
            key={recipe.data.path}
            path={recipe.data.path}
            element={<Recipe recipe={recipe.data} />}
          />
        ))}
      </Routes>
    </HashRouter>
  );
};

export default App;
